import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '@/lib/supabaseClient';
import AppHeader from './AppHeader';

interface AuthLayoutProps {
  children: React.ReactNode;
}

const AuthLayout: React.FC<AuthLayoutProps> = ({ children }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkSession = async () => {
      const { data: { session } } = await supabase.auth.getSession();
      if (!session) {
        navigate('/login');
      }
      setLoading(false);
    };

    checkSession();

    const { data: authListener } = supabase.auth.onAuthStateChange((_event, session) => {
      if (!session) {
        navigate('/login');
      }
    });

    return () => {
      authListener.subscription.unsubscribe();
    };
  }, [navigate]);

  if (loading) {
    return <div>Cargando...</div>; // O un spinner de carga adecuado
  }

  return (
    <div className="relative flex size-full min-h-screen flex-col bg-white group/design-root overflow-x-hidden" style={{ fontFamily: '"Public Sans", "Noto Sans", sans-serif' }}>
      <div className="layout-container flex h-full grow flex-col">
        <AppHeader />
        <main className="flex-grow p-4">{children}</main>
        <footer className="flex justify-center">
          <div className="flex max-w-[960px] flex-1 flex-col">
            <footer className="flex flex-col gap-6 px-5 py-10 text-center">
              <div className="flex flex-wrap items-center justify-center gap-6 @[480px]:flex-row @[480px]:justify-around">
                <a className="text-[#60758a] text-base font-normal leading-normal" href="#">Términos de Servicio</a>
                <a className="text-[#60758a] text-base font-normal leading-normal" href="#">Política de Privacidad</a>
                <a className="text-[#60758a] text-base font-normal leading-normal" href="#">Contáctanos</a>
              </div>
              <p className="text-[#60758a] text-base font-normal leading-normal">@2024 Inquilapp. Todos los derechos reservados.</p>
            </footer>
          </div>
        </footer>
      </div>
    </div>
  );
};

export default AuthLayout;
